// eslint-disable-next-line import/no-unresolved
import { registerSW } from 'virtual:pwa-register'
import userMonitoring from './userMonitoring'

export const initServiceWorker = registerSW({
  immediate: true,
  onRegisterError(error) {
    userMonitoring().trackError('Service Worker - Registration failed', error)
  },
  onRegisteredSW(serviceWorkerUrl: string, registration: ServiceWorkerRegistration | undefined) {
    if (registration) {
      // Log current service worker state
      userMonitoring().trackAction('Service Worker - Registered', {
        serviceWorkerUrl,
        state: registration.installing,
      })

      // Add state change listeners for installation tracking
      if (registration.installing) {
        registration.installing.addEventListener('statechange', (event) => {
          userMonitoring().trackAction('Service Worker - State changed', {
            state: (event.target as ServiceWorker).state,
          })
        })
      }

      // Listen for new service worker installation
      registration.addEventListener('updatefound', () => {
        const newWorker = registration.installing

        userMonitoring().trackAction('Service Worker - Found new', {
          newWorker,
        })

        newWorker?.addEventListener('statechange', (event) => {
          userMonitoring().trackAction('Service Worker - State changed', {
            state: (event.target as ServiceWorker).state,
          })
        })
      })

      // Listen for service worker updates
      setInterval(async () => {
        if (registration.installing || !navigator) return

        if ('connection' in navigator && !navigator.onLine) return

        const resp = await fetch(serviceWorkerUrl, {
          cache: 'no-store',
          headers: {
            cache: 'no-store',
            'cache-control': 'no-cache',
          },
        })

        if (resp?.status === 200) await registration.update()
      }, 60 * 60 * 1000) // 1 hour
    }
  },
})
